import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { UpdateTenderStatus } from '@/modules/Tenders/services'
import { HeartIcon, ThumbsDown } from 'lucide-react'

interface FollowButtonProps {
    tender_id: number
    is_followed: boolean | null
}

const FollowButton = ({ tender_id, is_followed }: FollowButtonProps) => {
    const { mutateAsync: updateTenderStatus } = useMutationWithHandler(
        {
            mutationFn: ({
                tender_id,
                is_followed,
            }: {
                tender_id: number
                is_followed: boolean
            }) => UpdateTenderStatus(tender_id, is_followed),
        },
        { reactQueryKeys: QUERY_KEYS.TENDERS }
    )

    return (
        <div className="flex items-center gap-4">
            <HeartIcon
                className={`w-4 h-4 cursor-pointer ${is_followed === true ? 'fill-red-500 text-red-500' : 'text-gray-300'}`}
                onClick={(e) => {
                    e.stopPropagation()
                    if (is_followed === false || is_followed === null) {
                        updateTenderStatus({
                            tender_id,
                            is_followed: true,
                        })
                    }
                }}
            />
            <ThumbsDown
                className={`w-4 h-4 cursor-pointer ${is_followed === false ? 'fill-gray-500 text-gray-500' : 'text-gray-300'}`}
                onClick={(e) => {
                    e.stopPropagation()
                    if (is_followed === true || is_followed === null) {
                        updateTenderStatus({
                            tender_id,
                            is_followed: false,
                        })
                    }
                }}
            />
        </div>
    )
}

export default FollowButton
